export default "__VITE_ASSET__f0c2f45b__"